import { FormTemplate } from './../../models/form/form-template';
import { PneAppointment } from './../../models/pne-emr/pne-emr.model';
import { SelectionModel } from '@angular/cdk/collections';
import { Form, SearchModel } from '@nrwl/rx-models';

export interface AccountLibraryState {
  library: any[];
  selectedFormGroups: SelectionModel<string>;
  selectedTemplates: FormTemplate[];
  editableTemplates: FormTemplate[];
  previewTemplate: FormTemplate;
  search: SearchModel;
  savedForms: Form[];
  isLoaded: boolean;
  error: string;
  patient: any;
  formTemplates: any[];
  formTemplatesTypeFilter: string | null;
  formCategories: any[];
  appointment: PneAppointment | null;
}

export const initialAccountLibraryState: AccountLibraryState = {
  library: [],
  selectedFormGroups: new SelectionModel<string>(true, []),
  selectedTemplates: [],
  editableTemplates: [],
  previewTemplate: null,
  search: new SearchModel(''),
  savedForms: [],
  isLoaded: false,
  error: '',
  patient: null,
  formTemplates: null,
  formTemplatesTypeFilter: null,
  formCategories: null,
  appointment: null,
};
